import React from 'react'
import ContactBody from '../components/ContactBody'
import HeaderNav from '../components/HeaderNav'

export default function Contact() {
  return (
    <div className='Contact'>
      <HeaderNav/>
      <ContactBody/>
    </div>
  )
}
